<div mat-dialog-content>
    <div class="customer-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-genCustomerNew (closeDialog)="onClose()" [customerId]="customerId"></app-genCustomerNew>
</div>